export const SplashActionType = {
  SET_PROPERTY_VALUE: 'SPLASH.SET_PROPERTY_VALUE',
  GET_LIST_API: 'SPLASH.GET_LIST_API',
  GET_LIST_API_SUCCESS: 'SPLASH.GET_LIST_API_SUCCESS',
  GET_LIST_API_FAILURE: 'SPLASH.GET_LIST_API_FAILURE',
  GET_BY_ID_API: 'SPLASH.GET_BY_ID_API',
  GET_BY_ID_API_SUCCESS: 'SPLASH.GET_BY_ID_API_SUCCESS',
  GET_BY_ID_API_FAILURE: 'SPLASH.GET_BY_ID_API_FAILURE',
  CHANGE_SPLASH_INPUT_VALUE: 'SPLASH.CHANGE_SPLASH_INPUT_VALUE',
  PUT_BY_ID_API: 'SPLASH.PUT_BY_ID_API',
  PUT_BY_ID_API_FAILURE: 'SPLASH.PUT_BY_ID_API_FAILURE',
  PUT_BY_ID_API_SUCCESS: 'SPLASH.PUT_BY_ID_API_SUCCESS',
  DELETE_BY_ID_API: 'SPLASH.DELETE_BY_ID_API',
  DELETE_BY_ID_API_FAILURE: 'SPLASH.DELETE_BY_ID_API_FAILURE',
  DELETE_BY_ID_API_SUCCESS: 'SPLASH.DELETE_BY_ID_API_SUCCESS',
  SET_ORIGINAL_SPLASH_VALUE: 'SPLASH.SET_ORIGINAL_SPLASH_VALUE',
  POST_BY_ID_API: 'SPLASH.POST_BY_ID_API',
  POST_BY_ID_API_FAILURE: 'SPLASH.POST_BY_ID_API_FAILURE',
  POST_BY_ID_API_SUCCESS: 'SPLASH.POST_BY_ID_API_SUCCESS',
  REPOSITION_SPLASH_ITEM: 'SPLASH.REPOSITION_SPLASH_ITEM',
  REPOSITION_SPLASH_ITEM_FAILURE: 'SPLASH.REPOSITION_SPLASH_ITEM_FAILURE',
  REPOSITION_SPLASH_ITEM_SUCCESS: 'SPLASH.REPOSITION_SPLASH_ITEM_SUCCESS',
}
